enum Types {
  NEW_OPERATOR_REQUEST = 'NEW_OPERATOR_REQUEST',
  NEW_OPERATOR_FULFILLED = 'NEW_OPERATOR_FULFILLED',
  NEW_OPERATOR_REJECTED = 'NEW_OPERATOR_REJECTED',

  NEW_OPERATOR_AT_GROUP_REQUEST = 'NEW_OPERATOR_AT_GROUP_REQUEST',
  NEW_OPERATOR_AT_GROUP_FULFILLED = 'NEW_OPERATOR_AT_GROUP_FULFILLED',
  NEW_OPERATOR_AT_GROUP_REJECTED = 'NEW_OPERATOR_AT_GROUP_REJECTED',

  CHANGE_LANGUAGE_REQUEST = 'CHANGE_LANGUAGE_REQUEST',
  CHANGE_LANGUAGE_FULFILLED = 'CHANGE_LANGUAGE_FULFILLED',
  CHANGE_LANGUAGE_REJECTED = 'CHANGE_LANGUAGE_REJECTED',

  RESET_MFA_TO_OPERATOR_REQUEST = 'RESET_MFA_TO_OPERATOR_REQUEST',
  RESET_MFA_TO_OPERATOR_FULFILLED = 'RESET_MFA_TO_OPERATOR_FULFILLED',
  RESET_MFA_TO_OPERATOR_REJECTED = 'RESET_MFA_TO_OPERATOR_REJECTED',

  UPDATE_PERMISSIONS_REQUEST = 'UPDATE_PERMISSIONS_REQUEST',
  UPDATE_PERMISSIONS_FULFILLED = 'UPDATE_PERMISSIONS_FULFILLED',
  UPDATE_PERMISSIONS_REJECTED = 'UPDATE_PERMISSIONS_REJECTED',

  ENABLE_OR_DISABLE_MFA_OPERATOR_REQUEST = 'ENABLE_OR_DISABLE_MFA_OPERATOR_REQUEST',
  ENABLE_OR_DISABLE_MFA_OPERATOR_FULFILLED = 'ENABLE_OR_DISABLE_MFA_OPERATOR_FULFILLED',
  ENABLE_OR_DISABLE_MFA_OPERATOR_REJECTED = 'ENABLE_OR_DISABLE_MFA_OPERATOR_REJECTED',

  REMOVE_OPERATOR_REQUEST = 'REMOVE_OPERATOR_REQUEST',
  REMOVE_OPERATOR_FULFILLED = 'REMOVE_OPERATOR_FULFILLED',
  REMOVE_OPERATOR_REJECTED = 'REMOVE_OPERATOR_REJECTED',

  GET_OPERATOR_TOKENS_REQUEST = 'GET_OPERATOR_TOKENS_REQUEST',
  GET_OPERATOR_TOKENS_FULFILLED = 'GET_OPERATOR_TOKENS_FULFILLED',
  GET_OPERATOR_TOKENS_REJECTED = 'GET_OPERATOR_TOKENS_REJECTED',

  NEW_OPERATOR_TOKEN_REQUEST = 'NEW_OPERATOR_TOKEN_REQUEST',
  NEW_OPERATOR_TOKEN_FULFILLED = 'NEW_OPERATOR_TOKEN_FULFILLED',
  NEW_OPERATOR_TOKEN_REJECTED = 'NEW_OPERATOR_TOKEN_REJECTED',

  REMOVE_OPERATOR_TOKEN_REQUEST = 'REMOVE_OPERATOR_TOKEN_REQUEST',
  REMOVE_OPERATOR_TOKEN_FULFILLED = 'REMOVE_OPERATOR_TOKEN_FULFILLED',
  REMOVE_OPERATOR_TOKEN_REJECTED = 'REMOVE_OPERATOR_TOKEN_REJECTED',

  EDIT_OPERATOR_TOKEN_REQUEST = 'EDIT_OPERATOR_TOKEN_REQUEST',
  EDIT_OPERATOR_TOKEN_FULFILLED = 'EDIT_OPERATOR_TOKEN_FULFILLED',
  EDIT_OPERATOR_TOKEN_REJECTED = 'EDIT_OPERATOR_TOKEN_REJECTED',

  RESERT_PASSWORD_REQUEST = 'RESERT_PASSWORD_REQUEST',
  RESERT_PASSWORD_FULFILLED = 'RESERT_PASSWORD_FULFILLED',
  RESERT_PASSWORD_REJECTED = 'RESERT_PASSWORD_REJECTED',

  EDIT_OPERATOR_REQUEST = 'EDIT_OPERATOR_REQUEST',
  EDIT_OPERATOR_FULFILLED = 'EDIT_OPERATOR_FULFILLED',
  EDIT_OPERATOR_REJECTED = 'EDIT_OPERATOR_REJECTED',

  GET_OPERATOR_REQUEST = 'GET_OPERATOR_REQUEST',
  GET_OPERATOR_FULFILLED = 'GET_OPERATOR_FULFILLED',
  GET_OPERATOR_REJECTED = 'GET_OPERATOR_REJECTED',

  GET_ALL_OPERATORS_REQUEST = 'GET_ALL_OPERATORS_REQUEST',
  GET_ALL_OPERATORS_FULFILLED = 'GET_ALL_OPERATORS_FULFILLED',
  GET_ALL_OPERATORS_REJECTED = 'GET_ALL_OPERATORS_REJECTED',

  TOGGLE_BLOCK_OPERATOR_REQUEST = 'TOGGLE_BLOCK_OPERATOR_REQUEST',
  TOGGLE_BLOCK_OPERATOR_FULFILLED = 'TOGGLE_BLOCK_OPERATOR_FULFILLED',
  TOGGLE_BLOCK_OPERATOR_REJECTED = 'TOGGLE_BLOCK_OPERATOR_REJECTED',

  UPDATE_MFA_REQUEST = 'UPDATE_MFA_REQUEST',
  UPDATE_MFA_FULFILLED = 'UPDATE_MFA_FULFILLED',
  UPDATE_MFA_REJECTED = 'UPDATE_MFA_REJECTED',

  SET_PENDING_PERMISSIONS_REQUEST = 'SET_PENDING_PERMISSIONS_REQUEST',

  SET_OPERATOR_DETAILS_REQUEST = 'SET_OPERATOR_DETAILS_REQUEST',
  SET_OPERATOR_DETAILS_FULFILLED = 'SET_OPERATOR_DETAILS_FULFILLED',
  SET_OPERATOR_DETAILS_REJECTED = 'SET_OPERATOR_DETAILS_REJECTED',

  GET_OPERATOR_ROLES_REQUEST = 'GET_OPERATOR_ROLES_REQUEST',
  GET_OPERATOR_ROLES_FULFILLED = 'GET_OPERATOR_ROLES_FULFILLED',
  GET_OPERATOR_ROLES_REJECTED = 'GET_OPERATOR_ROLES_REJECTED',
}

export default Types;
